module.exports = __webpack_public_path__ + "img/s8Bg5.3f81080a.jpg";